import React, {Component} from 'react';
import Feedback from './component/feedback';
class Footer extends Component{
    constructor(props) {
        super(props);
        this.feedback = this.feedback.bind(this);
    }
    feedback(e){
        e.preventDefault();
        Feedback();
    }
    render(){
        return (
            <div className="g-ft g-ft-noplaybar g-ft-reward">
                <div className="m-ft s-fc19">
                    <p>
                        <a href="/about/" target="_blank" className="s-fc19">关于网易</a>
                        <span className="line">|</span>
                        <a href="http://help.163.com/" target="_blank" className="s-fc19">客户服务</a>
                        <span className="line">|</span>
                        <a href="https://st.music.163.com/official-terms/service" target="_blank" className="s-fc19">服务条款</a>
                        <span className="line">|</span>
                        <a href="http://sitemap.163.com/" target="_blank" className="s-fc19">网站导航</a>
                        <span className="line">|</span>
                        <a href="#" onClick={this.feedback} className="s-fc19">意见反馈</a>
                    </p>
                    <p className="s-fc19">
                        <span className="sep">网易公司版权所有©1997-{new Date().getFullYear()}</span>杭州乐读科技有限公司运营：<a className="s-fc19" href="//p1.music.126.net/-DB9zs1FAJq8vg7HOb-yOQ==/3250156395654666.jpg" target="_blank">浙网文[2015] 0415-135号</a>
                    </p>                      
                </div>
            </div>
        )
    }
}
export default Footer;


// WEBPACK FOOTER //
// ./client/footer.js